'use strict'
import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import CallAPI from '../commonComponents/AxiosHelper';
import LoadingComponent from '../commonComponents/LoadingComponent'
import TableComponent from '../commonComponents/TableComponent';
import ButtonComponent from '../commonComponents/ButtonComponent';
import ModalComponent from '../commonComponents/ModalComponent';
import Form from '../commonComponents/Form';
import DatasetFilter from './DatasetFilter';
import { Prompt } from 'react-router-dom';

class TableParent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            clearFlag: 0
        }
        this.importFile = this.importFile.bind(this);
        this.bulkEdit = this.bulkEdit.bind(this);
        this.handleButton = this.handleButton.bind(this);
        this.clearSelection = this.clearSelection.bind(this);
        this.handleMenuAction = this.handleMenuAction.bind(this);
        this.bulkOperations = this.bulkOperations.bind(this);
        this.exportFile = this.exportFile.bind(this);
        this.getEditStatus = this.getEditStatus.bind(this);
        this.handleModalButtonAction = this.handleModalButtonAction.bind(this);
        this.showChangedRows = this.showChangedRows.bind(this);
        this.handleActionArray = this.handleActionArray.bind(this);
        this.handleExtraButtons = this.handleExtraButtons.bind(this);
        this.clearForm = this.clearForm.bind(this);

        this.menuData = {
            "clear": { "name": "clear", "label": "Clear Selected Rows", "action": this.clearSelection },
            "bulk": { "name": "bulk", "label": "Edit", "action": this.bulkEdit }
        }
        this.editFlag = props.editFlag ? props.editFlag : 0;
    }

    componentDidMount() {
        // gridOptions.api.sizeColumnsToFit();
        jQuery(".custom-file-input").on("change", function () {
            var fileName = jQuery(this).val().split("\\").pop();
            jQuery(this).siblings(".custom-file-label").addClass("selected").html(fileName);
        });
    }
//need to check 
    // shouldComponentUpdate(nextProps, nextState) {
    //     if (this.props.data?.data === nextProps.data?.data) {
    //         return false;
    //     }
    //     return true;
    // }

    bulkEdit(e) {
        let that = this;
        if (e && e.target.id == "bulk_form") {
            e.preventDefault();
            this.handleButton(null, 1);
            let selected_data = gridOptions.api.getSelectedNodes();
            let fetchedData = this.props.editData;
            let bulk_values = jQuery("#bulk_form").serializeArray();

            selected_data.map((element, i) => {
                bulk_values.map((innerData, j) => {
                    if (that.props.parentConfig[innerData.name] && that.props.parentConfig[innerData.name][innerData.value]) {
                        if (innerData.value == "None") {
                            innerData.value = null;
                        }
                        fetchedData[element['id']][innerData.name] = innerData.value;
                        fetchedData[element['id']]['rockmetric_update'] = true;
                        if (fetchedData[element['id']]['rockmetric_update_columns'] == undefined) {
                            fetchedData[element['id']]['rockmetric_update_columns'] = []
                        }
                        if (!fetchedData[element['id']]['rockmetric_update_columns'].includes(innerData.name)) {
                            fetchedData[element['id']]['rockmetric_update_columns'].push(innerData.name);
                        }
                        // fetchedData[element['id']]['rockmetric_update_columns'].push(innerData.name);
                    }
                })
            });

            this.props.handleDataUpdate(fetchedData);
            jQuery("#addBulkContent").modal('toggle');
            jQuery("#addBulkContent").trigger("reset");
            // this.showChangedRows(selected_data);
        }
        else {
            jQuery('#addBulkContent').modal('show');
        }

    }


    handleButton(e = null, open = null) {
        if ((e && e.target.id == "editButton") || open === 1) {
            jQuery("#saveButton").removeAttr('hidden');
            jQuery("#cancelButton").removeAttr('hidden');
            jQuery("#editButton").attr('hidden', true);
            this.editFlag = 1;
        }
        else if (e.target.id == "cancelButton") {
            jQuery("#saveButton").attr('hidden', true);
            jQuery("#cancelButton").attr('hidden', true);
            jQuery("#editButton").removeAttr('hidden');
            this.editFlag = 0;
            this.clearSelection();
            window.location.reload();
            // gridOptions.api.stopEditing(true);
            // gridOptions.api.stopEditing(cancel=true);
        }
    }



    clearSelection() {
        gridOptions.api.deselectAll();
        this.setState({
            clearFlag: 1
        })
    }


    clearForm(form_id) {
        let formId = `#${form_id}`;
        jQuery(formId).find(':input').each(function () {
            switch (this.type) {
                case 'password':
                case 'number':
                case 'select-multiple':
                case 'select-one':
                case 'email':
                case 'text':
                case 'textarea':
                case 'file':
                    jQuery(this).val('');
                    break;
                case 'checkbox':
                case 'radio':
                    this.checked = false;
            }
        });
    }

    handleMenuAction(name) {
        let menu = (this.props.customMenu !== undefined && this.props.customMenu !== null) ? this.props.customMenu : this.menuData;
        if (this.props.appendMenu !== undefined && this.props.appendMenu !== null) {
            menu = { ...menu, ...this.props.appendMenu }
        }

        let method = menu[name]["action"];
        return method;
    }

    bulkOperations(e) {
        if (e.target.id == "exportCSV") {
            let date = new Date();
            let page_file_name = this.props.filename;
            let fileName = `${page_file_name}_${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
            gridOptions.api.exportDataAsCsv({ fileName: fileName });
        }
        else if (e.target.id == "fileFormat") {
            this.exportFile();
        }
        else if (e.target.id == "importCSV") {
            jQuery('#importModal').modal('toggle');
        }
        else if (e.target.id == "addSecondaryButton") {
            jQuery('#addSecondaryContent').modal('toggle');
        }

    }

    exportFile(params) {
        gridOptions.api.shouldRowBeSkipped();
    }

    getEditStatus(params = null) {

        if (params == null) {
            return this.editFlag;
        }
        if (params.column.colDef.custom_editable) {
            let flag = 0;
            if (params.data.isDisabled !== undefined && params.data.isDisabled == true) {
                return flag;
            }
            else if (this.editFlag == 1 || params.data.isDisabled == true) {
                flag = 1
            }

            return flag;
        }
        return false;
    }


    importFile(e) {
        let that = this;
        let fileElement = document.getElementById('customFile');
        if (fileElement.files[0]) {
            var file = fileElement.files[0];
            if (file.type == "text/csv") {
                var reader = new FileReader();
                var text = null;
                let data_json = null;
                reader.onload = function (e) {
                    text = e.target.result;
                    data_json = that.props.importJSON(text);
                };
                reader.readAsText(file);
            }
            else {
                alert("Please Upload a CSV File!");
            }
        }
        else {
            alert("Please Upload a File!");
        }
    }

    handleModalButtonAction(e) {
        if (e.target.id == "add_form") {
            this.props.saveHandle(e);
            if (this.props.page !== "uploadTable" && this.props.page !== "dataset") {
                this.clearForm("add_form");
            }
            this.handleButton(null, 1);
        } else if (e.target.id == "bulk_form") {
            this.bulkEdit(e);
            if (this.props.page !== "uploadTable" && this.props.page !== "dataset") {
                this.clearForm("add_form");
            }
            this.handleButton(null, 1);

        } else if (e.target.id == "import_form") {
            e.preventDefault()
            var formData = { "copyData": 0 };
            let checkValidity = true;
            $("#import_form").serializeArray().map(function (innerData) {
                formData[`${innerData.name}`] = innerData.value;
            })
            checkValidity = checkValidity ? (checkSpecialChars(formData['newDatasetName']) ? false : true) : false
            if (checkValidity === false) {
                alert('Please enter valid inputs!\n(Only alphabets, numbers, hyphen(-) & underscore(_) are allowed.)');
            } else {
                let actualFormData = new FormData()
                Object.keys(formData).map(function (innerData) {
                    actualFormData.append(innerData, formData[innerData])
                })
                if (jQuery("#fileImport") && jQuery("#fileImport")[0].files[0]) {
                    let file = jQuery('#fileImport')[0].files[0];
                    actualFormData.append('zipFile', file)
                }
                actualFormData.append('user', encodePassword(this.props.authData.userId))
                let params = {
                    siteId: this.props.authData.siteId,
                    auth: "system"
                }
                CallAPI('POST', '/app/system/importJSON', actualFormData, params, 1, function (response) {
                    if (response.status === true) {
                        alert(response.information)
                    } else alert("Please upload appropriate file")
                    jQuery('#importModal').modal('toggle');
                }, this.props.authData)
                setTimeout(() => {
                    this.props.fetchDatasetData();
                }, 2000);
            }
        } else if (e.target.id === "dataQuality_form") {
            e.preventDefault()
            let parameters = {
                siteId: this.props.authData.siteId,
                auth: "system",
                type: "pdf"
            }
            let selectedTable = null, userID = this.props.authData.userId
            this.props.editData && this.props.editData.map(function (innerData) {
                if (innerData.toolId === gridOptions.api.getSelectedNodes()[0]['data']['toolId']) {
                    selectedTable = innerData.raw_table
                }
            })
            if (selectedTable === null || selectedTable === undefined) {
                selectedTable = `customer_${this.props.authData.siteId}.rawlog_${gridOptions.api.getSelectedNodes()[0]['data']['toolId']}_${this.props.authData.siteId}`;
            }
            let postData = {
                "tableName": selectedTable,
                "api_request": true,
                'user': userID,
                'userId': userID
            }
            CallAPI('POST', '/app/system/fetchDataQuality', postData, parameters, 0, function (response) {
                if (response.status === true) {
                    alert(response.information)
                    window.open("/adminpanel/v2/apirequest/admin")
                } else alert(response.error_message);
                jQuery('#dataQualityModal').modal('toggle');
            })
        } else if (e.target.id === "rawlog_form") {
            e.preventDefault()
            let parameters = {
                siteId: this.props.authData.siteId,
                //gridOptions.api.getSelectedNodes()[0]['data']['toolId']
                toolId: selectedDataset
            }
            var postData = {}, dimensionsArray = [], checkValidity = true
            $("#rawlog_form").serializeArray().map(function (innerData) {
                if (innerData.name === 'dimensions') {
                    dimensionsArray.push(innerData.value)
                } else postData[innerData.name] = innerData.value;
            })
            postData['dimensions'] = dimensionsArray.toString()
            if (checkValidity) {
                checkValidity = checkSpecialChars(postData['rawlog']) ? false : true
            }
            if (checkValidity == false) {
                alert('Please enter valid inputs!\n(Only alphabets, numbers, hyphen(-) & underscore(_) are allowed.)')
            } else {
                CallAPI('POST', '/app/changeRawLogConnection', postData, parameters, 0, function (response) {
                    if (response.status === true) {
                        alert(response.information)
                    } else alert(response.error_message)
                    jQuery('#changeRawlogModal').modal('toggle')
                }, this.props.authData)
            }
        } else if (e.target.id === "refreshFilter_form") {
            jQuery('#refreshFilterModal').modal('toggle');
            e.preventDefault()
            let selectedOption = $("#refreshFilter_form").serializeArray()
            if (selectedOption) {
                let params = {
                    siteId: localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null,
                    toolId: selectedDataset,
                    type: 'filter',
                    refresh: selectedOption[0].value,
                    auth: "system"
                }
                isDataLoading(true)
                CallAPI('GET', '/app/system/bulkUpdate', null, params, 0, function (response) {
                    alert("Filters Refreshed Successfully!")
                    isDataLoading(false)
                }, this.props.authData)
            }
        } else if (e.target.id === "syncData_form") {
            e.preventDefault()
            let formObject = {}
            $("#syncData_form").serializeArray().map(function (innerData) {
                formObject[`${innerData.name}`] = innerData.value;
            })
            let postData = [{
                "rockmetric_update": true,
                "rockmetric_update_columns": ["sync_frequency"],
                "toolId": this.props.toolId,
                "sync_frequency": formObject
            }]
            let params = {
                // siteId: this.props.authData.siteId,
                // userId: this.props.authData.userId,
                // email: this.props.authData.username
            }
            CallAPI('POST', '/app/rename_dataset', postData, params, 0, function (response) {
                if (response.status === true) {
                    alert(response.information)
                } else alert(response.error_message);
                jQuery('#syncDataModal').modal('toggle');
            }, this.props.authData)
        } else if (e.target.id === "syncDataset_form") {
            e.preventDefault();
            let params = { siteId: localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null, auth: 'system' }
            let postData = {
                'api_request': true,
                'toolId': (gridOptions.api.getSelectedNodes())[0]['data']['toolId'],
                'name': (gridOptions.api.getSelectedNodes())[0]['data']['label']
            }
            $("#syncDataset_form").serializeArray().map(function (innerData) {
                postData[`${innerData.name}`] = innerData.value;
            })
            CallAPI('POST', '/app/system/sync_dataset', postData, params, 0, function (response) {
                alert(response.information)
                jQuery('#syncDatasetModal').modal('toggle');
                window.open('/adminpanel/v2/apirequest/admin', '_blank')
            }, this.props.authData)
        }
    }

    showChangedRows(data_nodes = null) {
        // gridOptions.api.flashCells({ rowNodes: [rowNode1, rowNode2] });/
        let rowNode = (data_nodes !== null) ? { rowNodes: data_nodes } : { rowNodes: gridOptions.api.getDisplayedRowAtIndex(1) }
        gridOptions.api.flashCells(rowNode);

    }

    handleActionArray() {
        let menu = (this.props.customMenu !== undefined && this.props.customMenu !== null) ? this.props.customMenu : this.menuData;

        if (this.props.appendMenu !== undefined && this.props.appendMenu !== null) {
            // let innerMenu = {};
            // let appendMenu = Object.values(this.props.appendMenu).reduce((acc, item, index) => {
            //     acc[item.name] = item
            //     return acc;
            // }, innerMenu);            
            menu = { ...menu, ...this.props.appendMenu };
        }
        return menu;
    }

    handleExtraButtons() {

        let buttons = null;

        if (this.props.buttonConfig['custom'] !== null && this.props.buttonConfig['custom'] !== undefined) {
            let extraButtonConfig = Object.values(this.props.buttonConfig['custom']);
            buttons = extraButtonConfig.map((element, i) => {
                return (<ButtonComponent key={`${i}`} buttonConfig={element} action={element[0] ? element[0]['onClick'] : null} />)
            });

            return buttons;
        }


    }

    // handleExtraModal() {
    //     let extraModalConfig = Object.values(this.props.modalConfig['custom']);

    //     let modals = extraModalConfig.map((element, i) => {

    //         return (<ModalComponent modalConfig={element} action={this.handleModalButtonAction} />);

    //     });

    //     return buttons;
    // }

    render() {
        // if (this.props.data) {
        var mainData = (
            <TableComponent
                data={this.props.data}
                metrics={this.props.columns_array}
                setWidth={true}
                noRowsAvailable={this.props.noRowsAvailable}
                showTotalRow={false}
                chartEnable={false}
                selectbox={this.props.selectBox}
                headerSelectBox={this.props.headerSelectBox}
                sort={true}
                tablerendered={true}
                label={this.props.firstColumn}
                firstColumnShow={this.props.firstColumnShow || this.props.firstColumnShow === false ? this.props.firstColumnShow : true}
                edit={this.getEditStatus}
                index={1}
                buttonColumnArray={this.props.buttonColumnArray ? this.props.buttonColumnArray : null}
                width={200}
                pagination={this.props.pagination}
                rowsPerPage={this.props.rowsPerPage}
                side_columns={false}
                drillAcross={1}
                onCellChange={this.props.onCellChange}
                // actionArray={(this.props.customMenu !== undefined && this.props.customMenu !== null)?this.props.customMenu:this.menuData}
                actionArray={this.handleActionArray()}
                menuAction={this.handleMenuAction}
                handleRowStyle={this.props.handleRowStyle ? this.props.handleRowStyle : null}
                rowSelection={this.props.rowSelection}
                firstCellEdit={this.props.firstCellEdit}
                firstCellRender={(this.props.firstCellRender !== null && this.props.firstCellRender !== undefined) ? this.props.firstCellRender : null}
                firstColumnField={this.props.firstColumnField ? this.props.firstColumnField : 'label'}
                restrictOption={(this.props.restrictOption !== null && this.props.restrictOption !== undefined) ? this.props.restrictOption : null}
                tableStyle={this.props.tableStyle}
                // exportFile={this.exportFile}
                noMetricFunction={true}
                iconDisplay={this.props.iconDisplay ? this.props.iconDisplay : null}
                link={this.props.link ? this.props.link : false}
                loadingMessage={this.props.loadingMessage}
                noFilters={this.props.noFilters ? this.props.noFilters : false}
                openDatasetOnDoubleClick={this.props.openDatasetOnDoubleClick}
            />
        );


        var modal_data = [];
        if (this.props.modalConfig) {

            if (this.props.modalConfig["addModal"] !== null && this.props.modalConfig["addModal"] !== undefined) {
                modal_data.push(<ModalComponent modalConfig={this.props.modalConfig["addModal"]} formSubmit={this.handleModalButtonAction} />)
            }
            if (this.props.modalConfig["addSecondaryModal"] !== null && this.props.modalConfig["addSecondaryModal"] !== undefined) {
                modal_data.push(<ModalComponent modalConfig={this.props.modalConfig["addSecondaryModal"]} formSubmit={this.handleModalButtonAction} />)
            }

            {/* Bulk Edit Modal */ }
            if (this.props.modalConfig["bulkModal"] !== null && this.props.modalConfig["bulkModal"] !== undefined) {
                modal_data.push(<ModalComponent modalConfig={this.props.modalConfig["bulkModal"]} formSubmit={this.handleModalButtonAction} />)
            }

            {/* Import Modal */ }
            if (this.props.modalConfig["importModal"] !== null && this.props.modalConfig["importModal"] !== undefined) {
                modal_data.push(<ModalComponent modalConfig={this.props.modalConfig["importModal"]} formSubmit={this.handleModalButtonAction} cancelEvent={this.clearForm('import_form')} />)
            }

            {/* DataQuality Modal */ }
            if (this.props.modalConfig["dataQualityModal"] !== null && this.props.modalConfig["dataQualityModal"] !== undefined) {
                modal_data.push(<ModalComponent modalConfig={this.props.modalConfig["dataQualityModal"]} formSubmit={this.handleModalButtonAction} />)
            }

            {/* ChangeRawlog Modal */ }
            if (this.props.modalConfig["changeRawlogModal"] !== null && this.props.modalConfig["changeRawlogModal"] !== undefined) {
                modal_data.push(<ModalComponent modalConfig={this.props.modalConfig["changeRawlogModal"]} formSubmit={this.handleModalButtonAction} />)
            }

            {/* Refresh Filter Modal */ }
            if (this.props.modalConfig["refreshFilterModal"] !== null && this.props.modalConfig["refreshFilterModal"] !== undefined) {
                modal_data.push(<ModalComponent modalConfig={this.props.modalConfig["refreshFilterModal"]} formSubmit={this.handleModalButtonAction} />)
            }

            {/* SyncData Modal */ }
            if (this.props.modalConfig["syncDataModal"] !== null && this.props.modalConfig["syncDataModal"] !== undefined) {
                modal_data.push(<ModalComponent modalConfig={this.props.modalConfig["syncDataModal"]} formSubmit={this.handleModalButtonAction} />)
            }

            {/* SyncDataset Modal */ }
            if (this.props.modalConfig["syncDatasetModal"] !== null && this.props.modalConfig["syncDatasetModal"] !== undefined) {
                modal_data.push(<ModalComponent modalConfig={this.props.modalConfig["syncDatasetModal"]} formSubmit={this.handleModalButtonAction} />)
            }

            modal_data.push((this.props.modalConfig["updateModal"] !== null && this.props.modalConfig["updateModal"] !== undefined) ? <ModalComponent modalConfig={this.props.modalConfig["updateModal"]} action={() => this.props.updateModalAction("updateModal")} /> : null)
            if (this.props.modalConfig["featureRestrictionModal"] !== null && this.props.modalConfig["featureRestrictionModal"] !== undefined) {
                modal_data.push((this.props.modalConfig["featureRestrictionModal"] !== null && this.props.modalConfig["featureRestrictionModal"] !== undefined) ? <ModalComponent modalConfig={this.props.modalConfig["featureRestrictionModal"]} action={() => this.props.updateModalAction("featureRestrictionModal")} /> : null)
            }
        }

        return (
            <>
                <div className={`flex-row d-flex ${this.props.isReportingButton ? "" : "mg-t-10" } mg-b-10`}>
                    {/* <Prompt
                        when={this.getEditStatus() == 1?true:false}
                        // when={false}
                        message={`Leave without saving changes?`}
                    />  */}
                    {/* add button trigger modal */}
                    {/* <div className="d-sm-flex mg-l-auto"> */}
                    <div className="d-flex">
                        {this.props.topSearchBar ? this.props.topSearchBarDiv : null}
                        <div >
                            {this.props.buttonConfig && this.props.buttonConfig["addButton"] ? <ButtonComponent buttonConfig={this.props.buttonConfig["addButton"]} action={null} /> : null}
                        </div>
                        {this.props.selectedReport ? this.props.selectedReport : null}
                        {this.props.buttonConfig && this.props.buttonConfig['custom'] ? this.handleExtraButtons() : null}
                    </div>
                    {/* </div> */}

                    {/* <div className="mg-l-auto"> */}

                    <div className="d-flex mg-l-auto" role="toolbar" aria-label="Toolbar with button groups">
                        <div className="btn-group" role="group" aria-label="Edit group">
                            <div>
                                {this.props.buttonConfig && this.props.buttonConfig["editButton"] ? <ButtonComponent buttonConfig={this.props.buttonConfig["editButton"]} action={this.handleButton} /> : null}
                            </div>
                        </div>
                        <div className="btn-group" role="group" aria-label="Save group">
                            {/* Save button */}
                            <div>
                                {this.props.buttonConfig && this.props.buttonConfig["saveButton"] ? <ButtonComponent buttonConfig={this.props.buttonConfig["saveButton"]} action={this.props.submitHandle} /> : null}
                            </div>
                        </div>
                        <div className="btn-group " role="group" aria-label="Load group">
                            {/* Loading Button */}
                            <div>
                                {this.props.buttonConfig && this.props.buttonConfig["loadingButton"] ? <ButtonComponent buttonConfig={this.props.buttonConfig["loadingButton"]} /> : null}
                            </div>
                        </div>
                        <div className="btn-group " role="group" aria-label="Cancel group">
                            {/* Cancel Button */}
                            <div>
                                {this.props.buttonConfig && this.props.buttonConfig["cancelButton"] ? <ButtonComponent buttonConfig={this.props.buttonConfig["cancelButton"]} action={this.handleButton} /> : null}
                            </div>
                        </div>
                        {this.props.buttonConfig && this.props.buttonConfig["dropdownConfig"] ? <ButtonComponent buttonConfig={this.props.buttonConfig["dropdownConfig"]} action={this.bulkOperations} dropdownItemActions={this.props.dropdownItemActions ? this.props.dropdownItemActions : false} /> : null}
                    </div>
                    {/* Edit Button */}

                    {/* Dropdown Button */}
                    


                    {/* </div> */}
                </div>
                <div className="">
                    {/* Table Component */}
                    {mainData}
                </div>

                {modal_data}
            </>
        )
    }

}

function mapStateToProps(state) {
    return { toolId: state.admin.toolId, authData: state.dataSet.authData };
};

export default connect(mapStateToProps)(TableParent);